import axios from '@/axios'

export const getLocation = (data) => axios.post('/filingSearch/scope', data)
export const getCaseList = (data) => axios.post('/onlineDelivery/deliveryList', data)
export const getCaseDetail = (data) => axios.post('/onlineDelivery/deliveryDetail', data)
export const docBookUpload = (data) => axios.post('/docBook/uploadPub', data)

//获取文书列表
export const getDocuments = (data) => axios.post('/allInOne/getDocuments', data)
export const createOrPreviewDocument = (data) => axios.post('/allInOne/createOrPreviewDocument', data)
//获取文书
export const downloadDocument = (data) => axios.get('/allInOne/downloadDocument/' + data)



// WEBPACK FOOTER //
// ./src/api/documentService.js